// extracted by mini-css-extract-plugin
export default {"root":"s7f3Y0e3Ia"};